import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-xinjiantianjiabiaodanyemian",
  "use": "icon-xinjiantianjiabiaodanyemian-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-xinjiantianjiabiaodanyemian\"><path d=\"M640 288 640 64 192 64C121.344 64 64 121.344 64 192l0 704c0 70.656 57.344 128 128 128l576 0c70.656 0 128-57.344 128-128L896 320l-224 0C654.336 320 640 305.664 640 288zM704 544C704 561.664 689.664 576 672 576L512 576l0 160C512 753.664 497.664 768 480 768S448 753.664 448 736L448 576 288 576C270.336 576 256 561.664 256 544S270.336 512 288 512L448 512 448 352C448 334.336 462.336 320 480 320S512 334.336 512 352L512 512l160 0C689.664 512 704 526.336 704 544zM704 64l0 192 192 0L704 64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/xinjiantianjiabiaodanyemian.svg
// module id = N0bj
// module chunks = 12